import { useQuery } from '@tanstack/react-query';
import getLiveAccount from 'Api/live-account/getLiveAccount';
import { getLiveAccountRequest } from './model/request/getLiveAccountRequest';
import getLiveAccountResponse from './model/response/getLiveAccountResponse';

const useGetLiveAccount = (queryParams) => {
  return useQuery({
    queryKey: ['live-account', queryParams],
    queryFn: async () => {
      const queries = getLiveAccountRequest(queryParams);

      const response = await getLiveAccount(queries);

      const result = getLiveAccountResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetLiveAccount;
